import { SurveyMode, SurveyView } from '../v2/slices/surveySlice';

export const isThankYouView = (view: SurveyMode): boolean => {
  return view === SurveyView.ThankYou;
};

export const isSurveyTakingView = (view: SurveyMode): boolean => {
  return view === SurveyView.Taking;
};

export const isCloseWindowView = (view: SurveyMode): boolean => {
  return view === SurveyView.CloseWindow;
};

export default { isThankYouView, isSurveyTakingView, isCloseWindowView };
